import React, { Component } from 'react';

import LocaleUtils from './LocaleUtils';

import { ENTER } from './keys';

type LocaleUtilsType = {
  formatMonthTitle: (date: Date, locale?: string) => string;
};

type CaptionProps = {
  labelledby?: string;
  date: Date;
  months?: Array<string>;
  locale?: string;
  localeUtils?: LocaleUtilsType;
  onClick?: (e: React.MouseEvent | React.KeyboardEvent) => void;
  classNames: {
    caption: string;
  };
};

export default class Caption extends Component<CaptionProps> {
  static defaultProps = {
    localeUtils: LocaleUtils,
  };

  constructor(props: CaptionProps) {
    super(props);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  shouldComponentUpdate(nextProps: CaptionProps) {
    return (
      nextProps.locale !== this.props.locale ||
      nextProps.classNames !== this.props.classNames ||
      nextProps.date.getMonth() !== this.props.date.getMonth() ||
      nextProps.date.getFullYear() !== this.props.date.getFullYear()
    );
  }

  handleKeyUp(e: React.KeyboardEvent) {
    if (e.keyCode === ENTER && this.props.onClick) {
      this.props.onClick(e);
    }
  }

  render() {
    const { classNames, date, months, locale, localeUtils, onClick, labelledby } = this.props;
    return (
      <div className={classNames.caption} role="heading" aria-level={2} aria-live="polite" aria-labelledby={labelledby}>
        <div onClick={onClick} onKeyUp={this.handleKeyUp}>
          {months ? `${months[date.getMonth()]} ${date.getFullYear()}` : localeUtils?.formatMonthTitle(date, locale)}
        </div>
      </div>
    );
  }
}
